(() => {
  'use strict';
  const root = document.querySelector('[data-pdp-v2]');
  if (!root) return;
  const strings = JSON.parse(root.querySelector('[data-pdp-strings]').textContent);
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const form = root.querySelector('.p2-form');
  const submit = form.querySelector('[data-add-to-cart]');
  const offers = form.querySelector('fieldset');
  const error = root.querySelector('[data-cart-error]');
  const quantity = () => Number(form.querySelector('[name="quantity"]:checked')?.value || 1);
  let busy = false;
  const setLabel = () => {
    if (busy || !form.querySelector('[name="quantity"]:checked:not(:disabled)')) return;
    const n = quantity();
    submit.querySelector('[data-add-label]').textContent = (n === 1 ? strings.addOne : strings.addMany.replace('{quantity}', n));
  };
  form.addEventListener('change', setLabel);

  const hero = root.querySelector('#p2-title');
  const customerHeading = root.querySelector('.p2-customer-title');
  const fitNoWrapText = element => {
    const parent = element.parentElement;
    const parentStyle = getComputedStyle(parent);
    const available = parent.clientWidth - (parseFloat(parentStyle.paddingLeft) || 0) - (parseFloat(parentStyle.paddingRight) || 0);
    element.style.fontSize = '';
    let low = 12;
    let high = parseFloat(getComputedStyle(element).fontSize) || 48;
    for (let i = 0; i < 16; i++) {
      const mid = (low + high) / 2;
      element.style.fontSize = `${mid}px`;
      if (element.getBoundingClientRect().width <= available) low = mid;
      else high = mid;
    }
    element.style.fontSize = `${low}px`;
  };
  const fitHeroLines = () => hero?.querySelectorAll('.p2-headline-line').forEach(fitNoWrapText);
  const fitCustomerHeading = () => { if (customerHeading) fitNoWrapText(customerHeading); };
  const fitResponsiveCopy = () => { fitHeroLines(); fitCustomerHeading(); };
  if ('ResizeObserver' in window) {
    const copyObserver = new ResizeObserver(fitResponsiveCopy);
    if (hero) copyObserver.observe(hero);
    if (customerHeading) copyObserver.observe(customerHeading.parentElement);
  }
  document.fonts?.ready.then(fitResponsiveCopy);
  requestAnimationFrame(fitResponsiveCopy);

  const tabs = [...root.querySelectorAll('[role="tab"]')];
  const panels = [...root.querySelectorAll('[role="tabpanel"]')];
  const activateTab = (index, closeAnswers = true) => {
    tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
    panels.forEach((panel, i) => {
      panel.hidden = i !== index;
      if (closeAnswers) panel.querySelectorAll('details').forEach(detail => { detail.open = false; });
    });
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(index));
    tab.addEventListener('keydown', event => {
      let next = index;
      if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (index + 1) % tabs.length;
      else if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (index + tabs.length - 1) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault(); activateTab(next); tabs[next].focus({ preventScroll: true });
    });
  });

  const track = root.querySelector('[data-gallery]');
  const thumbs = [...root.querySelectorAll('[data-thumb]')];
  let currentImage = 0;
  const paintGallery = index => {
    currentImage = Math.max(0, Math.min(index, thumbs.length - 1));
    thumbs.forEach((thumb, i) => { if (i === currentImage) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current'); });
    root.querySelector('[data-gallery-count]').textContent = String(currentImage + 1);
  };
  const resetGallery = () => {
    track.classList.add('p2-gallery-resetting');
    track.scrollLeft = 0;
    paintGallery(0);
    requestAnimationFrame(() => requestAnimationFrame(() => track.classList.remove('p2-gallery-resetting')));
  };
  resetGallery();
  window.addEventListener('pageshow', resetGallery);
  const showImage = (index, instant = false) => {
    index = Math.max(0, Math.min(index, thumbs.length - 1));
    paintGallery(index);
    track.scrollTo({ left: index * track.clientWidth, behavior: instant || reducedMotion.matches ? 'instant' : 'smooth' });
  };
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showImage(i)));
  track.addEventListener('scroll', () => {
    const index = Math.round(track.scrollLeft / track.clientWidth);
    paintGallery(index);
  }, { passive: true });
  track.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault(); showImage(currentImage + (event.key === 'ArrowRight' ? 1 : -1));
  });
  const lightbox = root.querySelector('.p2-lightbox');
  root.querySelectorAll('[data-zoom]').forEach(button => button.addEventListener('click', () => {
    const source = button.querySelector('img');
    const image = lightbox.querySelector('img');
    image.src = source.src.replace('-780.webp', '.webp'); image.alt = source.alt;
    lightbox.showModal();
  }));
  lightbox.querySelector('button').addEventListener('click', () => lightbox.close());
  lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });

  // Restore open content before the shared routing script restores vertical position.
  // Otherwise expanded answers would disappear, changing the page height on return.
  const memoryKey = 'vessa_pdp_v2_ui';
  const isReturn = location.hash === '#return' || ['reload', 'back_forward'].includes(performance.getEntriesByType('navigation')[0]?.type);
  let savedUI;
  try { savedUI = JSON.parse(sessionStorage.getItem(memoryKey)); } catch {}
  if (isReturn && savedUI) {
    activateTab(Math.max(0, Math.min(tabs.length - 1, Number(savedUI.tab) || 0)), false);
    const opened = new Set(savedUI.open || []);
    root.querySelectorAll('details[id]').forEach(detail => { detail.open = opened.has(detail.id); });
  }
  const saveUI = () => {
    try { sessionStorage.setItem(memoryKey, JSON.stringify({ tab: tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'), open: [...root.querySelectorAll('details[open][id]')].map(el => el.id) })); } catch {}
  };
  root.querySelectorAll('details').forEach(detail => {
    const summary = detail.querySelector('summary');
    const answer = summary.nextElementSibling;
    if (answer) { answer.id = detail.id + '-answer'; summary.setAttribute('aria-controls', answer.id); }
    const sync = () => summary.setAttribute('aria-expanded', String(detail.open));
    sync();
    detail.addEventListener('toggle', () => {
      sync();
      const group = detail.closest('[data-accordion-group]');
      if (detail.open && group) group.querySelectorAll('details[open]').forEach(other => { if (other !== detail) other.open = false; });
    });
  });
  window.addEventListener('pagehide', saveUI);
  root.querySelectorAll('a[href]').forEach(link => link.addEventListener('click', saveUI));

  const base = root.dataset.root || '/';
  const requestJSON = async (path, body) => {
    const response = await fetch(base + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}) });
    let result;
    try { result = await response.json(); } catch { throw new Error(strings.error); }
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : strings.error);
    return result;
  };
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy) return;
    const selected = quantity();
    const variant = Number(root.dataset.variant);
    busy = true; submit.disabled = true; offers.disabled = true; submit.setAttribute('aria-busy', 'true');
    submit.querySelector('[data-add-label]').textContent = strings.adding;
    error.hidden = true; saveUI();
    try {
      const cart = await requestJSON('cart.js');
      const matching = cart.items.filter(item => item.variant_id === variant && !item.selling_plan_allocation);
      if (matching.length) {
        // Set the selected supply, never add it on top of the previous attempt.
        const updates = Object.fromEntries(matching.map((item, index) => [item.key, index === 0 ? selected : 0]));
        await requestJSON('cart/update.js', { updates });
      } else {
        await requestJSON('cart/add.js', { items: [{ id: variant, quantity: selected }] });
      }
      const updated = await requestJSON('cart.js');
      const actual = updated.items.filter(item => item.variant_id === variant && !item.selling_plan_allocation).reduce((sum, item) => sum + item.quantity, 0);
      if (actual !== selected) throw new Error(strings.error);
      const destination = new URL(base + 'checkout', location.origin);
      const query = new URLSearchParams(location.search);
      query.forEach((value, key) => { if (/^utm_/.test(key) || ['fbclid', 'gclid', 'ttclid', 'msclkid'].includes(key)) destination.searchParams.set(key, value); });
      location.assign(destination.pathname + destination.search);
    } catch (err) {
      error.textContent = err.message || strings.error; error.hidden = false;
      busy = false; offers.disabled = false; submit.disabled = false; submit.removeAttribute('aria-busy'); setLabel();
    }
  });
  window.addEventListener('pageshow', async () => {
    busy = false; offers.disabled = false; submit.disabled = !form.querySelector('[name="quantity"]:not(:disabled)'); submit.removeAttribute('aria-busy'); setLabel();
    try {
      const cart = await requestJSON('cart.js');
      document.querySelectorAll('[data-cart-count]').forEach(badge => { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; });
    } catch {}
  });
  setLabel();

  root.dataset.ready = 'true';
})();
